export { default } from './getDuration'
